import React from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import {Shield, FileCheck, Clock} from 'lucide-react'

const Guarantee = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })

  return (
    <section ref={ref} className="py-20 md:py-32 bg-gradient-to-br from-gray-900 via-[#0D7FA3] to-[#C64DAD] relative overflow-hidden">
      {/* Animated background */}
      <motion.div
        animate={{ scale: [1, 1.3, 1], rotate: [0, 90, 0] }}
        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
        className="absolute top-0 left-0 w-96 h-96 bg-yellow-300 rounded-full blur-3xl opacity-10"
      />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={inView ? { scale: 1 } : {}}
              transition={{ duration: 0.6, type: "spring" }}
              className="inline-flex items-center justify-center w-24 h-24 bg-yellow-300 rounded-full mb-8 shadow-2xl"
            >
              <Shield className="w-12 h-12 text-gray-900" strokeWidth={2} />
            </motion.div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Aqui o compromisso é{' '}
              <span className="text-yellow-300">conjunto</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="bg-white/10 backdrop-blur-md border-2 border-white/20 rounded-3xl p-8 md:p-12 mb-8"
          >
            <p className="text-2xl md:text-3xl text-white leading-relaxed text-center font-light mb-8">
              Nós confiamos tanto no nosso método que{' '}
              <span className="font-bold text-yellow-300">assumimos o risco junto com você</span>.
            </p>

            <div className="bg-yellow-300 rounded-2xl p-8 md:p-10">
              <p className="text-xl md:text-2xl text-gray-900 font-bold text-center leading-relaxed">
                Se seguindo a metodologia do EW Pass você{' '}
                <span className="bg-gray-900 text-yellow-300 px-3 py-1 rounded-lg">
                  não perceber evolução no seu inglês em até 6 meses
                </span>
                , devolvemos o valor investido.
              </p>
            </div>
          </motion.div>

          {/* Trust indicators */}
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: FileCheck, title: 'Formalizado', description: 'Tudo em contrato' },
              { icon: Shield, title: 'Transparência', description: 'Sem letras miúdas' },
              { icon: Clock, title: '6 meses', description: 'Tempo de garantia' },
            ].map((item, index) => {
              const Icon = item.icon
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 text-center hover:bg-white/15 transition-all duration-300"
                >
                  <Icon className="w-10 h-10 text-yellow-300 mx-auto mb-4" strokeWidth={2} />
                  <h4 className="text-xl font-bold text-white mb-2">{item.title}</h4>
                  <p className="text-white/80">{item.description}</p>
                </motion.div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Guarantee
